import axios from "axios";
import { Config } from "../config";

const config = new Config();

// Every call below used to carry a bearer token that shipped inside this bundle.
// They now go to the BFF, which holds the token server-side and only accepts requests
// carrying the session cookie issued by /bff/login.
const api = axios.create({
  baseURL: config.settings.BffApiUrl,
  withCredentials: true,
});

export const getFeatureViewList = async () => {
  const res = await api.get("features");
  return res.data;
};

export const getClientFlowList = async (
  featureId: number,
  clientCode: string
) => {
  const res = await api.get("feature/client-flows", {
    params: { featureId, clientCode: clientCode || undefined },
  });
  return res.data;
};

export const getClientsList = async () => {
  const res = await api.get("clients");
  return res.data;
};

export const upsertClientFlows = async (data: any) => {
  const res = await api.post("flows/upsert", data);
  return res.data;
};

export const getFlowActionsList = async (flowId: number) => {
  const res = await api.get("flows/actions", { params: { flowId } });
  return res.data;
};

export const getModelsList = async (clientCode: string) => {
  const res = await api.get("models", { params: { clientCode } });
  return res.data;
};

export const upsertFlowAction = async (data: any, flowId: number) => {
  const res = await api.post("actions/upsert", data, { params: { flowId } });
  return res.data;
};

export const getActionDetails = async (actionId: number) => {
  const res = await api.get("actions", { params: { actionId } });
  return res.data;
};

export const getDeleteFlow = async (clientCode: string, flowId: number) => {
  const res = await api.delete("flows", { params: { clientCode, flowId } });
  return res.data;
};

export const getDeleteFlowAction = async (actionId: number) => {
  const res = await api.delete("actions", { params: { actionId } });
  return res.data;
};

export const getWritingAssistantFlowsList = async () => {
  const res = await api.get("wa/flows");
  return res.data;
};

export const getCloneOfFlow = async (flowId: number, clientCode: string) => {
  const res = await api.post("wa/clone", {}, { params: { flowId, clientCode } });
  return res.data;
};

export const getMediaLibraryIcon = async (clientCode: any) => {
  const res = await api.get("media/icons", { params: { clientCode } });
  return res.data;
};

export const getActionGroups = async (flowId: number) => {
  const res = await api.get("action-groups", { params: { flowId } });
  return res.data;
};

export const AddActionGroups = async (data: any) => {
  const res = await api.post("action-groups/upsert", data);
  return res.data;
};

export const getDeleteActionGroup = async (actionGroupId: number) => {
  const res = await api.delete("action-groups", { params: { actionGroupId } });
  return res.data;
};

export const login = async (username: string, password: string) => {
  const res = await api.post("login", { username, password });
  return res.data;
};

export const logout = async () => {
  const res = await api.post("logout");
  return res.data;
};

export const getSession = async () => {
  const res = await api.get("session");
  return res.data;
};
